import getPaginationPages from "./getPaginationPages";

export default getPaginationPages;
